import { MessagePlugin } from 'tdesign-react';

import { IMateriallDetail } from '@/store/modules/material';
import { transformObjectDeep } from '@/utils/tans/object';

import { apiPathServer } from './api-config';
import { CgiErrorCode, CgiResp } from './cgi';
import { API_PREFIX_MATERIAL, request } from './request';

/**
 * 拉取整体详情接口
 */
export const fetchMaterialDetail = async (id: string) => {
  const res = await request<CgiResp<IMateriallDetail>>(`${API_PREFIX_MATERIAL}${apiPathServer.materialDetail}`, {
    query: {
      id,
    },
  });
  if (res.code !== CgiErrorCode.NO_ERROR) {
    MessagePlugin.error(res.message || '信息拉取失败，请稍后重试');
  }
  return transformObjectDeep(res?.data, 'camel') as IMateriallDetail;
};
/**
 * 获取下载链接
 * @param id
 * @returns
 */
export const fetchMaterialDownloadUrl = async (id: string) => {
  const res = await request<CgiResp<string>>(`${API_PREFIX_MATERIAL}${apiPathServer.materialDownload}`, {
    query: {
      material_id: id,
    },
  });
  if (res.code !== CgiErrorCode.NO_ERROR) {
    MessagePlugin.error(res.message || '信息拉取失败，请稍后重试');
  }
  return res.data;
};

/**
 * 保存整体数据
 * @param material
 * @returns
 */
export const modifyMaterialDetail = async (material: IMateriallDetail) => {
  const res = await request(`${API_PREFIX_MATERIAL}${apiPathServer.postMaterial}`, {
    method: 'POST',
    body: transformObjectDeep({ data: material }, 'snake'),
  });
  return res;
};

/**
 * 删除配置信息
 */
export const deleteMaterial = async (id: string) => {
  const res = await request(`${API_PREFIX_MATERIAL}${apiPathServer.deleteMaterial}`, {
    method: 'POST',
    body: { ids: [id] },
  });
  return res;
};

interface IMaterial {
  id: string;
  name: string;
  updatedBy: string;
  updatedTime: string;
}

/**
 * 拉取列表
 * @param id
 * @returns
 */
export const fetchMaterialList = async ({
  page = 1,
  size = 10,
}: {
  page?: number;
  size?: number;
}): Promise<{
  list: IMaterial[];
  pageInfo: {
    total: number;
    current: number;
    pageSize: number;
  }
}> => {
  const res = await request(`${API_PREFIX_MATERIAL}${apiPathServer.materialList}`, {
    query: {
      page,
      size,
    },
  });
  const { list, pageinfo: pageInfo } = res?.data;
  return {
    list: list?.map((item: any) => transformObjectDeep(item, 'camel')) || [],
    pageInfo: {
      total: pageInfo?.total || 0,
      current: pageInfo?.page || 1,
      pageSize: pageInfo?.size || 10,
    },
  };
};
